export default __webpack_public_path__ + "static/media/php.866aa06f.png";